import { createRouter, createWebHashHistory } from 'vue-router'
import { useSellerStore } from '@stores/SellerStore'
import api from '../axios';

const beforeUnloadHandler = (event) => {
  // Recommended
  event.preventDefault();

  // Included for legacy support, e.g. Chrome/Edge < 119
  event.returnValue = true;
};

const routes = [
    {
      path: "/listing/:regno",
      component: () => import("@components/Sales.vue"),
      beforeEnter: async (to, from, next) => {
        const sellerStore = useSellerStore()
        await sellerStore.getTrafiData(to.params.regno)
        let errors = sellerStore.errors.getTrafiData
        if(errors) {
          switch(errors.code) {
            case 423:
              next({name: 'locked'})
              break;
            default:
              next({name: 'car'})
              break;
          }
        }
        await sellerStore.getQuestions()
        next()
      },
      children: [
        {
          path: "",
          name: "car",
          component: () => import("@components/salesComponents/StepOne.vue"),
          beforeEnter: () => window.addEventListener('beforeunload', beforeUnloadHandler)
        },
        {
          path: "damage",
          name: "damage",
          component: () => import("@components/salesComponents/StepTwo.vue"),
        },
        {
          path: "contact",
          name: "contact",
          component: () => import("@components/salesComponents/StepThree.vue"),
        },
        {
          path: "done",
          name: "done",
          component: () => import("@components/salesComponents/StepFour.vue"),
          beforeEnter: () => window.removeEventListener('beforeunload', beforeUnloadHandler)
        },
      ],
    },
    {
      path: "/car/:hash",
      name: "winner",
      component: () => import("@components/CarPage.vue"),      
    },
    
    // Always leave this as last one,
    // but you can also remove it
    {
      path: "/error",
      name: 'error',
      component: () => import("@components/500.vue"),
    },
    {
      path: "/locked",
      name: 'locked',
      component: () => import("@components/423.vue"),
    },
    {
      path: "/:catchAll(.*)*",
      name: 'notfound',
      component: () => import("@components/404.vue"),
    },
  ];

  const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
  })

  router.beforeEach(async (to, from) => {
    const sellerStore = useSellerStore();
    
    const storeData = JSON.parse(JSON.stringify(sellerStore.listing));
    let fileLog = [];
    for (let index = 0; index < sellerStore.files.length; index++) {
      const file = sellerStore.files[index];
      fileLog.push({filename: file.name, type: file.type, size: file.size})
    }
    storeData.files = JSON.parse(JSON.stringify(fileLog));
    storeData.regno_from = from.params.regno ?? null;
    storeData.regno_to = to.params.regno ?? null;
    // console.log("Route change", storeData);

    api.post('/log', {data: storeData});
  })
  
  export default router;
  